import { IWebsiteCharacterRace } from "../../interfaces";
import { barbarian, dwarf, gnome, highelf, human, rogue, woodelf } from ".";

const entries: Array<IWebsiteCharacterRace> = [barbarian, dwarf, gnome, highelf, human, rogue, woodelf];

export default entries;
